import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import fetchDux from '../../../state/fetch-dux';
import { Link } from 'react-router-dom';
import moment from 'moment';
import { actionCreators } from '../../../state/modals-dux';

import AssetForm from './asset-form/AssetForm';
import {
  Row,
  Col,
  Button,
  Label,
  DropdownButton,
  MenuItem
} from 'react-bootstrap';
import DeleteAssetModal from './DeleteAssetModal';
import DeleteVersionModal from './DeleteVersionModal';
import RevisionModal from './RevisionModal';
import PublishAssetModal from './PublishAssetModal';
import RestoreVersionModal from './RestoreVersionModal';
import CloneAssetModal from './CloneAssetModal';

import EditAsset from './EditAsset';
import CreateAsset from './CreateAsset';

const AssetDetailSection = (
  {
    data,
    asset,
    onTogglePublished,
    onRestore,
    onEditVersionName,
    onDeleteAsset,
    onDeleteVersion,
    onEditAsset,
    onCloneAsset
  }
) => {
  if (!data) return false;

  const { assetParent, activeVersion, previewLink, assetType, _id } = data || {
  };
  const { published } = assetParent || {};

  const { opts } = asset || {};
  const { single } = opts || {};

  return (
    <div>
      <div className="asset-preview-actions">

        {!single &&
          <Button
            bsStyle="primary"
            onClick={onDeleteAsset}
            style={{ float: 'left' }}
          >
            Delete All Versions
          </Button>}

        {previewLink &&
          <Button bsStyle="hollow-info" target="_blank" href={previewLink.href}>
            {previewLink.text || 'Preview'}
          </Button>}
        {' '}
        <Link to={`/pages/${assetType}/edit/${_id}`}>
          <Button bsStyle="hollow-info">
            <span className="ti ti-pencil" />
          </Button>
        </Link>
        {' '}
        <Button bsStyle="hollow-primary" onClick={onDeleteVersion}>
          <span className="ti ti-trash" />
        </Button>
        {' '}
        {!single &&
          <Button
            bsStyle={published ? 'hollow-primary' : 'hollow-success'}
            onClick={onTogglePublished}
          >
            {published ? 'Disable' : 'Enable'}
          </Button>}
        {' '}
        {!single &&
          <Button bsStyle="hollow-info" onClick={onCloneAsset}>
            Clone
          </Button>}
        {' '}
        <Button bsStyle="success" onClick={onRestore}>Publish</Button>
      </div>
      <div className="asset-preview">
        {/*
        <div style={{ textAlign: 'right' }}>
          <DropdownButton
            noCaret
            title={<span className="ti ti-list" />}
            id="dropdown-asset-detail"
          >
            <MenuItem eventKey="1" onSelect={onEditAsset}>Edit Version</MenuItem>
            {!activeVersion && (
              <MenuItem eventKey="2" onSelect={onRestore}>Restore Version</MenuItem>
            )}
            <MenuItem eventKey="3" onSelect={onDeleteVersion}>Delete Version</MenuItem>
            <MenuItem divider />
            <MenuItem eventKey="4" onSelect={onTogglePublished}>
              {published === true ? 'Unpublish Asset' : 'Publish Asset'}
            </MenuItem>
            <MenuItem eventKey="5" onSelect={onDeleteAsset}>Delete Asset</MenuItem>
          </DropdownButton>
        </div>
        */}
        <table className="table">
          <tr>
            <th>Version Name</th>
            <td>
              {data.versionName}
              <Button
                bsSize="xs"
                bsStyle="hollow-info"
                onClick={onEditVersionName}
              >
                <span className="ti ti-pencil" />
              </Button>
            </td>
          </tr>
          <tr>
            <th>Date Created</th>
            <td>{moment(data.dateCreated).format('MM/DD/YYYY hh:mm a')}</td>
          </tr>
          <tr>
            <th>Last Updated</th>
            <td>{moment(data.lastUpdated).format('MM/DD/YYYY hh:mm a')}</td>
          </tr>
        </table>
      </div>
      <AssetForm asset={asset} initialValues={data} readOnly />
    </div>
  );
};

class AssetDetail extends Component {
  constructor(props) {
    super(props);
    this.handleRestore = this.handleRestore.bind(this);
    this.onEditVersionName = this.onEditVersionName.bind(this);
    this.handleRevisionSubmit = this.handleRevisionSubmit.bind(this);
    this.onDeleteAsset = this.onDeleteAsset.bind(this);
    this.handleDeleteAsset = this.handleDeleteAsset.bind(this);
    this.onDeleteVersion = this.onDeleteVersion.bind(this);
    this.handleDeleteVersion = this.handleDeleteVersion.bind(this);
    this.onEditAsset = this.onEditAsset.bind(this);
    this.handlePublishAsset = this.handlePublishAsset.bind(this);
    this.onTogglePublished = this.onTogglePublished.bind(this);
    this.handlePublishAsset = this.handlePublishAsset.bind(this);
    this.onRestoreVersion = this.onRestoreVersion.bind(this);
    this.onCloneAsset = this.onCloneAsset.bind(this);
    this.handleCloneSubmit = this.handleCloneSubmit.bind(this);
  }
  handleRestore() {
    const {
      match,
      restoreAsset,
      clearRestoreAsset,
      getAssetSiblings
    } = this.props;
    const { params } = match || {};
    const { type, id } = params || {};
    clearRestoreAsset();
    restoreAsset({ id, type }, null, null, () => {
      getAssetSiblings({ id, type });
    });
  }
  onEditVersionName() {
    this.props.showModal('RevisionModal');
  }
  onDeleteAsset() {
    this.props.showModal('DeleteAssetModal');
  }
  onDeleteVersion() {
    this.props.showModal('DeleteVersionModal');
  }
  onCloneAsset() {
    this.props.showModal('CloneAssetModal');
  }
  onEditAsset() {
    const { data, history } = this.props;
    const { _id, assetType } = data || {};
    history.push(`/pages/${assetType}/edit/${_id}`);
  }
  handleRevisionSubmit(payload) {
    const {
      data,
      asset,
      patchVersionName,
      getAssetSiblings
    } = this.props;
    const { _id } = data || {};
    const { assetType } = asset || {};

    patchVersionName(
      { id: _id, type: assetType, payload },
      'revision-form',
      null,
      () => {
        getAssetSiblings({ id: _id, type: assetType });
      }
    );
  }
  handleDeleteAsset() {
    const {
      data,
      deleteAsset
    } = this.props;

    if (!data) return;
    deleteAsset({ id: data.assetParentId }, null, null, () => {
      this.props.history.push(`/pages/${data.assetType}`);
    });
  }
  handleDeleteVersion() {
    const {
      data,
      deleteVersion,
      assetSiblings
    } = this.props;

    if (!data) return;
    deleteVersion({ id: data._id }, null, null, () => {
      const activeSibling = (assetSiblings || []).find(a => a.activeVersion);
      if (!activeSibling) return;
      this.props.history.push(`/pages/${data.assetType}/${activeSibling._id}`);
    });
  }
  onTogglePublished() {
    this.props.showModal('PublishAssetModal');
  }
  onRestoreVersion() {
    this.props.showModal('RestoreVersionModal');
  }
  handleCloneSubmit({ versionName }) {
    const { asset, postAsset, closeModal, data } = this.props;
    const { assetType } = asset || {};

    const payload = Object.assign(
      {},
      { data: (data || {}).data || {} },
      { versionName }
    );
    postAsset({ type: assetType, payload }, 'clone-asset-form', null, data => {
      closeModal();
      const { insertedIds } = data || {};
      this.props.history.push(`/pages/${assetType}/${insertedIds[0]}`);
    });
  }
  handlePublishAsset() {
    const {
      match,
      publishAsset,
      clearPublishAsset,
      data
    } = this.props;
    const { assetParent } = data || {};
    const { published } = assetParent || {};
    const { params } = match || {};
    const { type, id } = params || {};
    const payload = { published: !published };
    clearPublishAsset();
    publishAsset({ id, type, payload });
  }
  render() {
    const {
      assetSiblings,
      asset,
      data,
      inProgress,
      deleteAssetErr,
      deleteAssetInProgress,
      publishAssetInErr,
      publishAssetInProgress,
      restoreVersionErr,
      restoreVersionInProgress,
      children,
      isAssetDetail,
      match
    } = this.props;
    const { assetType, opts } = asset || {};
    const { single } = opts || {};

    const { params } = match || {};
    const { id } = params || {};

    if (inProgress) return <div>Loading</div>;
    const { versionName, assetParentId } = data || {};

    return (
      <div>
        <RevisionModal
          showCancel
          name="RevisionModal"
          title={`Edit Revision ${versionName}`}
          initialValues={{ versionName }}
          onRevisionSubmit={this.handleRevisionSubmit}
        />
        <CloneAssetModal
          showCancel
          name="CloneAssetModal"
          title={`Clone Version ${versionName}`}
          onCloneSubmit={this.handleCloneSubmit}
        />
        <DeleteAssetModal
          assetToDelete={data}
          handleDeleteAsset={this.handleDeleteAsset}
          deleteAssetErr={deleteAssetErr}
          deleteAssetInProgress={deleteAssetInProgress}
          label={(opts || {}).label}
        />
        <DeleteVersionModal
          versionToDelete={data}
          handleDeleteVersion={this.handleDeleteVersion}
          deleteAssetErr={deleteAssetErr}
          deleteAssetInProgress={deleteAssetInProgress}
        />
        <PublishAssetModal
          assetToPublish={data}
          handlePublishAsset={this.handlePublishAsset}
          publishAssetInErr={publishAssetInErr}
          publishAssetInProgress={publishAssetInProgress}
        />
        <RestoreVersionModal
          versionToRestore={data}
          handleRestoreVersion={this.handleRestore}
          restoreVersionErr={restoreVersionErr}
          restoreVersionInProgress={restoreVersionInProgress}
        />
        <div className="header asset">
          <div className="container-fluid">
            <Link
              className="back"
              to={single ? '/pages' : `/pages/${assetType}`}
            >
              <span className="ti ti-arrow-left" />
            </Link>
            <h1>
              <div>{(opts || {}).url}</div>
              <span>{(opts || {}).label}</span>
            </h1>
          </div>
        </div>
        <div className="container">
          <Row>
            <Col sm={3}>
              <Link
                to={`/pages/${assetType}/create/${assetParentId}`}
                className="pull-right"
              >
                <Button bsStyle="hollow-success" bsSize="xs">
                  <span className="ti ti-plus" /> Add Version
                </Button>
              </Link>
              <h4 className="versions">Versions</h4>
              {(assetSiblings || []).map(sibling => (
                <Link
                  to={`/pages/${assetType}/${sibling._id}`}
                  className={
                    id === sibling._id ? 'version-item active' : 'version-item'
                  }
                >
                  <div>
                    <strong>{sibling.versionName}</strong>
                    {sibling.activeVersion &&
                      <Label bsStyle="success">Published</Label>}
                    <em>
                      Created {moment(sibling.dateCreated).format('MM/DD/YYYY')}
                    </em>
                  </div>
                </Link>
              ))}
            </Col>
            <Col sm={9}>
              {!isAssetDetail && children}
              {isAssetDetail &&
                <AssetDetailSection
                  data={data}
                  asset={asset}
                  onTogglePublished={this.onTogglePublished}
                  onRestore={this.onRestoreVersion}
                  onEditVersionName={this.onEditVersionName}
                  onDeleteAsset={this.onDeleteAsset}
                  onDeleteVersion={this.onDeleteVersion}
                  onEditAsset={this.onEditAsset}
                  onCloneAsset={this.onCloneAsset}
                />}
            </Col>
          </Row>
        </div>
      </div>
    );
  }
}

const mapState = state => {
  const {
    error: deleteAssetErr,
    inProgress: deleteAssetInProgress
  } = state.deleteAsset.toJS();

  const {
    error: publishAssetInErr,
    inProgress: publishAssetInProgress
  } = state.publishAsset.toJS();

  const {
    error: restoreVersionErr,
    inProgress: restoreVersionInProgress
  } = state.restoreAsset.toJS();

  return {
    deleteAssetErr,
    deleteAssetInProgress,
    publishAssetInErr,
    publishAssetInProgress,
    restoreVersionErr,
    restoreVersionInProgress
  };
};
const mapDispatch = dispatch =>
  bindActionCreators(
    {
      ...actionCreators,
      restoreAsset: fetchDux.restoreAsset.createAction,
      clearRestoreAsset: fetchDux.restoreAsset.clearAction,
      publishAsset: fetchDux.publishAsset.createAction,
      clearPublishAsset: fetchDux.publishAsset.clearAction,
      patchVersionName: fetchDux.patchVersionName.createAction,
      clearPatchVersionName: fetchDux.patchVersionName.clearAction,
      deleteAsset: fetchDux.deleteAsset.createAction,
      clearDeleteAsset: fetchDux.deleteAsset.clearAction,
      deleteVersion: fetchDux.deleteVersion.createAction,
      clearDeleteVersion: fetchDux.deleteVersion.clearAction,
      getAssetSiblings: fetchDux.getAssetSiblings.createAction,
      postAsset: fetchDux.postAsset.createAction,
      clearPostAsset: fetchDux.postAsset.clearAction
    },
    dispatch
  );

export default connect(mapState, mapDispatch)(AssetDetail);



// WEBPACK FOOTER //
// ./src/components/routes/assets/AssetDetailLayout.js